import template from './range-slider.tmpl.html';

const DIRECTIVE_NAME = RangeSlider.DIRECTIVE_NAME = 'ktRangeSlider';
const RANGE_SLIDER_TYPES = {
    PRICE: 'price',
    TIME: 'time',
    DURATION: 'duration',
};

export default function RangeSlider() {
    return {
        restrict: 'A',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            minimum: `=${DIRECTIVE_NAME}Minimum`,
            maximum: `=${DIRECTIVE_NAME}Maximum`,
            type: `@${DIRECTIVE_NAME}Type`,
        },
        bindToController: true,
        controller: RangeSliderController,
        controllerAs: 'rangeSliderCtrl',
        template,
        link: {
            pre: preLink,
        },
    };

    function preLink($scope, $elem, $attrs, rangeSliderCtrl) {
        rangeSliderCtrl.$onInit();
    }
}

export function RangeSliderController(
    $scope,
    rangeSliderService
) {
    'ngInject';

    const vm = this;
    const TIME_RANGE_STEP = 1800000;

    Object.assign(vm, {
        $onInit,
        saveFromSlider,
        priceTranslate: rangeSliderService.priceTranslate,
        timeTranslate: rangeSliderService.timeTranslate,
        durationTranslate: rangeSliderService.durationTranslate,
    });

    function $onInit() {
        determineSliderType();
        initMinimumMaximum();
        updateSliderValues();
        watchOutsideModelChange();
    }

    function watchOutsideModelChange() {
        $scope.$watch(() => vm.model, () => {
            initMinimumMaximum();
            updateSliderValues();
        });
    }

    function determineSliderType() {
    const {PRICE, TIME, DURATION} = RANGE_SLIDER_TYPES;
    const sliderTypes = [PRICE, TIME, DURATION];
    return sliderTypes.includes(vm.type)
        ? vm.sliderType = vm.type
        : vm.sliderType = PRICE;
    }

    function initMinimumMaximum() {
        const {floor: minimum, ceiling: maximum} = vm.model;

        Object.assign(vm, {minimum, maximum});
        vm.options = {
            floor: minimum,
            ceil: maximum,
            precision: 2,
            enforceStep: false,
            enforceRange: true,
            step: vm.sliderType === RANGE_SLIDER_TYPES.DURATION ? TIME_RANGE_STEP : null,
            hideLimitLabels: true,
            onEnd: saveFromSlider,
            translate: getTranslateFunction(),
        };
    }

    function getTranslateFunction() {
        switch (vm.sliderType) {
            case RANGE_SLIDER_TYPES.PRICE:
                return vm.priceTranslate;
            case RANGE_SLIDER_TYPES.TIME:
                return vm.timeTranslate;
            case RANGE_SLIDER_TYPES.DURATION:
                return vm.durationTranslate;
            default:
                return vm.priceTranslate;
        }
    }

    function saveFromSlider() {
        vm.minimum = vm.sliderMinimum;
        vm.maximum = vm.sliderMaximum;
        Object.assign(vm.model, initRangeSlider(vm.minimum, vm.maximum));
    }

    function initRangeSlider(min, max) {
        return {
            model: min,
            range: max,
            floor: min,
            ceiling: max,
        };
    }

    function updateSliderValues() {
        vm.sliderMinimum = vm.minimum;
        vm.sliderMaximum = vm.maximum;
    }
}




// WEBPACK FOOTER //
// ./src/app/directives/range-slider/range-slider-component.js